const styles = (theme) => ({
    title: {
        fontWeight: '500',
    },
    containerTable: {
        overflow: 'hidden',
    },
    table: {
        margin: '0 0 30px 0',
    },
    tableRow: {
        verticalAlign: 'top',
    },
    tableRowAlignMiddle: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    addButton: {
        borderRadius: '30px',
        padding: '5px 20px',
        border: '1px solid #ccc',
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        backgroundColor: '#fff',
        alignItems: 'center',
        display: 'flex',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontFamily: theme.typography.fontFamily,
        float: 'right',
    },
    btnSigleAction: {
        minWidth: '30px',
        height: '30px',
        lineHeight: '30px',
        borderRadius: '50%',
        display: 'inline-flex',
        color: '#fff',
        marginRight: '5px',
        padding: '0',
        fontSize: '16px',
    },
});

export default styles;
